export default __webpack_public_path__ + "static/media/09.e7f9ac4c.jpg";